import { render, staticRenderFns } from "./UpdateProductsModal.vue?vue&type=template&id=14c05bd9&scoped=true"
import script from "./UpdateProductsModal.vue?vue&type=script&lang=js"
export * from "./UpdateProductsModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateProductsModal.vue?vue&type=style&index=0&id=14c05bd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c05bd9",
  null
  
)

export default component.exports